import React from 'react';
import { Link } from 'react-router-dom';
import { PHASE_FILTERS, formatLabel, type PhaseFilter } from './pocListUtils';

type PhaseTabsProps = {
  active: PhaseFilter;
  counts: Record<PhaseFilter, number>;
  showClear: boolean;
  onSelect: (phase: PhaseFilter) => void;
  onClear: () => void;
};

export const PhaseTabs: React.FC<PhaseTabsProps> = ({
  active,
  counts,
  showClear,
  onSelect,
  onClear,
}) => (
  <div className="poc-list__tabs-row">
    <div className="poc-list__tabs" role="toolbar" aria-label="Filter by phase">
      {PHASE_FILTERS.map((tab) => {
        const isActive = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            className={'poc-list__tab' + (isActive ? ' poc-list__tab--active' : '')}
            aria-pressed={isActive}
            onClick={() => onSelect(tab.id)}
          >
            {tab.label}
            <span className="poc-list__tab-count">{counts[tab.id]}</span>
          </button>
        );
      })}
    </div>
    {showClear ? (
      <button type="button" className="poc-list__clear" onClick={onClear}>
        Clear filters
      </button>
    ) : null}
  </div>
);

type SearchFieldProps = {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
};

export const SearchField: React.FC<SearchFieldProps> = ({
  label,
  placeholder,
  value,
  onChange,
}) => (
  <label className="poc-list__search">
    <span className="poc-list__sr-only">{label}</span>
    <svg className="poc-list__search-icon" viewBox="0 0 20 20" aria-hidden>
      <circle cx="9" cy="9" r="6" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M13.5 13.5L17 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
    <input
      type="search"
      className="poc-list__search-input"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      autoComplete="off"
    />
  </label>
);

export const PhasePill: React.FC<{ phase: string }> = ({ phase }) => (
  <span className={`poc-list__phase poc-list__phase--${phase.toLowerCase()}`}>
    {formatLabel(phase)}
  </span>
);

type EmptyStateProps = {
  title: string;
  text?: string;
  action?: { label: string; to?: string; onClick?: () => void };
};

export const EmptyState: React.FC<EmptyStateProps> = ({ title, text, action }) => (
  <div className="poc-list__empty" role="status">
    <strong>{title}</strong>
    {text ? <p>{text}</p> : null}
    {action?.to ? (
      <Link to={action.to} className="poc-list__empty-action">
        {action.label}
      </Link>
    ) : null}
    {action?.onClick ? (
      <button type="button" className="poc-list__empty-action" onClick={action.onClick}>
        {action.label}
      </button>
    ) : null}
  </div>
);
